import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import CreatorPlatform from "./CreatorPlatform";
import Marketplace from "./Marketplace";
import MarketplaceSecondaries from "./MarketplaceSecondaries";
import Videos from "./Videos";
import ItemDedicatedPage from "./ItemDedicatedPage";
import CreatorProfile from "./CreatorProfile";
import MyNFTs from "./MyNFTs";
import Platform from "./Platform";
import Build from "./Build";
import DisplayLiveStreamDetails from "./DisplayLiveStreamDetails";
import LiquidCreatorPlatform from "./LiquidCreatorPlatform";
import LiquidCreatorPlatformV2 from "./LiquidCreatorPlatformV2";
import ContinuousAuction from "./ContinuousAuction";
import NounsUploadPage from "./NounsUploadPage";
import ContinuousAuctionCollections from "./ContinuousAuctionCollections";
import Footer from "./Footer";
import StreamerProfile from "./StreamerProfile";
import CreatorDashboard from './CreatorDashboard';
import ClipButton from './ClipButton';
import Market from './Market';
import { useAccount } from "wagmi";

function AppWithRainbow(props) {
  const { address, connector } = useAccount();

  let account;
  if(address == null) {
    account = null;
  } else {
    account = {
      "address": address,
      "connector": connector
    }
  }

  return (
    <div>
    <Router>
      <Routes>
        { /* <Route
          path="/music"
          element={<Platform account={account} initiallyRetro={false} />}
        /> */ }
        <Route
          path="/upload"
          element={<CreatorPlatform account={account} />}
        />
        <Route
          path="/"
          element={<Videos account={account} />}
        />
        <Route
          path="/build"
          element={<Build account={account} />}
        />
        <Route
          path="/liquiduploadv2"
          element={<LiquidCreatorPlatformV2 account={account} />}
        />
        <Route
          path="/liquidupload"
          element={<LiquidCreatorPlatform account={account} />}
        />
        <Route
          path="/display-stream-details/:id"
          element={<DisplayLiveStreamDetails account={account} />}
        />
        <Route
          path="/display-stream-details/:id/:extra"
          element={<DisplayLiveStreamDetails account={account} />}
        />
        <Route
          path="/explore"
          element={<Videos account={account} />}
        />
        <Route
          path="/auction/:id"
          element={<ContinuousAuction account={account} />}
        />
        <Route
          path="/marketplace"
          element={<Marketplace account={account} />}
        />
        <Route
          path="/marketplace/:tokenId"
          element={<MarketplaceSecondaries account={account} />}
        />
        <Route
          path="/media/:tokenId"
          element={<ItemDedicatedPage account={account} />}
        />
        <Route
          path="/creator/profile/:address"
          element={<CreatorProfile account={account} />}
        />
        <Route
          path="/myNFTs"
          element={<MyNFTs account={account} />}
        />
        <Route
          path="/auctioncollections"
          element={<ContinuousAuctionCollections account={account} />}
        />
        <Route
          path="/nounsupload"
          element={<NounsUploadPage account={account} />}
        />
        <Route
          path="/dashboard"
          element={<CreatorDashboard account={account} />}
        />
        <Route
          path="/profile/:creator"
          element={<StreamerProfile account={account} />}
        />
        <Route
          path="/market"
          element={<Market account={account} />}
        />
        <Route
          path="/clip"
          element={<ClipButton account={account} />}
        />
      </Routes>
    </Router>
      <Footer/>
    </div>
  );
}

export default AppWithRainbow;